import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	FormWrapperLabel,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useRef } from 'react';
import { Controller } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import { MailScanned } from '../../../Types/MailFilterDataTypes';
import { SearchTypesType } from '../SearchControlTypes';

function SearchMailScanned(props: SearchTypesType) {
	const { t } = useTranslation();

	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.value = props.searchParams?.get('scanned')
				? (props.searchParams.get('scanned') as string)
				: '';
		}
	}, [props.searchParams]);

	return (
		<Controller
			name='scanned'
			control={props.formMethods.control}
			render={({ field, fieldState }) => (
				<FormWrapperLabel
					label={t('mailboxes.filter.labels.mailScanned')}
					invalid={fieldState.invalid}
					validationMessage={fieldState.error?.message}
				>
					<ComboBoxControl
						name='scanned'
						placeholder={t('mailboxes.filter.controls.mailScannedPlaceholder')}
						data={MailScanned}
						valueType='number'
						displayType={ComboBoxTypeEnum.Single}
						displayItemLabelType={ComboBoxItemDisplayEnum.Label}
						defaultValue={
							props.searchParams?.get('scanned')
								? [props.searchParams?.get('scanned') as string]
								: undefined
						}
						forwardValueCallback={(e) => {
							field.onChange(e);
						}}
					/>
				</FormWrapperLabel>
			)}
		/>
	);
}

export { SearchMailScanned };
